'use client';
import React from 'react';
import { Accordion } from '@mantine/core';
import { IconPlus } from '@/icons/IconPlus';
import { IMenuItem } from '@/interfaces/homepage';
import CustomLink from '@/components/CustomLink';
export default function CustomFooterAccordion({ Name, MenuItems }: { Name?: string; MenuItems?: IMenuItem[] }) {
  return (
    <Accordion
      defaultValue="customization"
      transitionDuration={500}
      chevron={<IconPlus className="w-5" />}
      styles={{
        chevron: {
          '&[dataRotate]': {
            transform: 'rotate(45deg)',
          },
        },
      }}
    >
      <Accordion.Item value="customization">
        <Accordion.Control>
          <h3 className="ml-12 text-center text-xl font-semibold capitalize text-black">{Name?.toLowerCase()}</h3>
        </Accordion.Control>
        <Accordion.Panel>
          <div className="">
            <ul className="mt-1 list-none pl-1 text-center">
              {MenuItems?.map((item) => (
                <li key={item?.Name} className="mb-1">
                  <CustomLink prefetch={false} href={'/page' + item?.PageUrl} className="text-base text-sonic-silver hover:underline">
                    {item?.Name}
                  </CustomLink>
                </li>
              ))}
            </ul>
          </div>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
